/**
 * Created by Administrador on 30/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('quantityCtrl', quantityCtrl)
        .controller('newEditQuantityCtrl', newEditQuantityCtrl)
        .controller('deleteQuantityCtrl', deleteQuantityCtrl);

    quantityCtrl.$inject = ['linkService', 'quantities'];

    newEditQuantityCtrl.$inject = ['quantityService', 'linkService', 'quantity','action','quantities','$stateParams'];

    deleteQuantityCtrl.$inject = ['quantity', 'quantityService', '$uibModalInstance','linkService'];

    function quantityCtrl(linkService, quantities){
        var vm = this;

        vm.quantities = (quantities.data._embedded) ? quantities.data._embedded.quantities : [];
        vm.linkService = linkService;
    }

    function newEditQuantityCtrl(quantityService, linkService, quantity, action,quantities,$stateParams){
        var vm = this;
        vm.linkService = linkService;
        vm.quantity = {};
        vm.quantities = (quantities.data._embedded) ? quantities.data._embedded.quantities : [];

        if(action == 'edit'){
            vm.quantity.name = quantity.data.name;
            vm.quantity.weight = quantity.data.weight;
            vm.quantity.percentage = quantity.data.percentage;
            vm.quantity.fixedAmount = quantity.data.fixedAmount;
            vm.quantity.quantityId = vm.linkService.getLinkId(quantity.data._links.self.href);
            vm.quantity.minQuantity = ($stateParams.index==0?0:(parseInt(vm.quantities[parseInt($stateParams.index)-1].weight))+2);
            vm.quantity.maxQuantity = ($stateParams.index==(vm.quantities.length-1)?99999:(parseInt(vm.quantities[parseInt($stateParams.index)+1].weight)-2));
        }else{
            vm.quantity.name = "air.quantity.table.quantityOver";
            vm.quantity.minQuantity = 0;
            vm.quantity.maxQuantity = 99999;
            if(quantities.data._embedded){
                vm.quantity.minQuantity = (parseInt(quantities.data._embedded.quantities[quantities.data._embedded.quantities.length-1].weight)+2);
            }
        }

        vm.save = function(isValid, quantity){
            if (isValid) {
                quantity.active = true;
                if(action == "new"){
                    quantityService.saveQuantity(quantity);
                }else{
                    quantityService.updateQuantity(vm.quantity.quantityId, vm.quantity)
                }
            }
        }
    }

    function deleteQuantityCtrl(quantity, quantityService, $uibModalInstance,linkService){
        var vm = this;
        vm.quantity = quantity.data;

        vm.delete = function(){
            quantityService.deleteQuantity(linkService.getLinkId(quantity.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
